// extracted by mini-css-extract-plugin
module.exports =  {"productCardList":"pl__ProductCardList-module__productCardList___uxgJC"};